import { SIBASI_SYSTEM_APP_MODULES } from 'src/app/common/model/sibasi-system.model';

export interface ITableColumn {
  displayName: string;
  sortField: string;
}

export interface IPagination<T = unknown> {
  data: T;
  page: number;
  pageSize: number;
  searchParam?: string;
  totalCount: number;
  sortKey?: string;
  sortDirection?: number;
  startDate?: string | null;
  endDate?: string | null;
  [key: string]: any;
}

export interface ITableHeaderDetails {
  icon: string;
  text: string;
}

export enum AutoCompleteSearchType {
  PROJECT = 'PROJECT',
  MEMBER = 'MEMBER',
  PLAN = 'PLAN',
  USER = 'USER',
  GROUP = 'GROUP',
  ASSET = 'ASSET',
  PAYYMENTTERMS = 'PAYYMENTTERMS',
  ITEMCATEGORIES = 'ITEMCATEGORIES',
  ITEMS = 'ITEMS',
  EXPENSESCATEGORIES = 'EXPENSESCATEGORIES',
  LOCATION = 'LOCATION',
  EMPLOYEE_POSITION = 'EMPLOYEE_POSITION',
  EMPLOYEE = 'EMPLOYEE',
  MODULETYPE = 'MODULETYPE',
  ASSETCATEGORIES = 'ASSETCATEGORIES',
  CUSTOMER = 'CUSTOMER',
  LEAD = 'LEAD',
  VENDOR = 'VENDOR'
}

export interface ISearchAutocomplete {
  searchType: AutoCompleteSearchType;
  fieldName: string;
  multiple?: boolean;
}

export enum EMeetingViewOptions {
  TABLE = 'TABLE',
  CALENDAR = 'CALENDAR'
}

export enum EDocumentViewOptions {
  TABLE = 'TABLE',
  THUMBNAIL = 'THUMBNAIL'
}

export enum ERecurrenceDuration {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  CUSTOM = 'CUSTOM'
}

export interface Image {
  name: string;
  objectURL: string;
}

export interface IModule {
  moduleType: SIBASI_SYSTEM_APP_MODULES;
  moduleItemId: string;
  moduleName?: string;
}

export enum EItemActions {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  READ = 'READ'
}

export enum EInsight {
  FILES = 'Files',
  MEETINGS = 'Meetings',
  ACTIONPOINTS = 'Action Points',
  MEMBERS = 'Members'
}

export enum EMessageSeverity {
  INFO = 'info',
  SUCCESS = 'success',
  WARN = 'warn',
  ERROR = 'error',
  SECONDARY = 'secondary',
  CONTRAST = 'contrast'
}
